import { isLocalUrl } from '../helpers';

export default function seoWidget(widgetNameVariable, widgetOptsVariable) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $widget.remove();
        $('.video-seoWidget-container').addClass('no-seoWidget');
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, URL } = widgetData[0];
    const localUrl = isLocalUrl(URL) ? '' : 'target="_blank"';

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <hr>
      <div class="seo-description">${Description}</div>
      ${URL == null ? '' : `<a href="${URL}" class="button" ${localUrl}>More</a>`}
    `);
  }
}
